export interface CustomerCreditInfo {
  customer: {
    id: string;
    name: string;
    code: string;
    creditLimit: number;
  };
  creditLimit: number;
  currentOutstanding: number;
  availableCredit: number;
  isOverLimit: boolean;
  pendingOrders: Array<{
    orderId: string;
    orderNumber: string;
    amount: number;
    status: string;
    orderDate: string;
    expectedDeliveryDate: string;
  }>;
  overdueAmount: number;
}

export interface CreditCheckResult {
  canProceed: boolean;
  creditLimit: number;
  currentOutstanding: number;
  newOutstanding: number;
  availableCredit: number;
  exceedAmount: number;
  message?: string;
}

export interface CreditCheckRequest {
  orderAmount: number;
  throwOnExceed?: boolean;
}

export interface CustomerOverLimit {
  customer: {
    id: string;
    name: string;
    code: string;
    creditLimit: number;
  };
  creditLimit: number;
  currentOutstanding: number;
  exceedAmount: number;
}

// Helper functions for display
export const getCreditStatusColor = (creditInfo: CustomerCreditInfo): string => {
  if (creditInfo.isOverLimit) return 'text-red-600';
  if (creditInfo.availableCredit < creditInfo.creditLimit * 0.1) return 'text-yellow-600';
  return 'text-green-600';
};

export const getCreditStatusBadge = (creditInfo: CustomerCreditInfo): string => {
  if (creditInfo.isOverLimit) return 'bg-red-100 text-red-800';
  if (creditInfo.availableCredit < creditInfo.creditLimit * 0.1) return 'bg-yellow-100 text-yellow-800';
  return 'bg-green-100 text-green-800';
};

export const getCreditStatusText = (creditInfo: CustomerCreditInfo): string => {
  if (creditInfo.isOverLimit) return 'Over Limit';
  if (creditInfo.availableCredit < creditInfo.creditLimit * 0.1) return 'Near Limit';
  return 'Within Limit';
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
  }).format(amount);
};